import { Component, OnInit } from '@angular/core';
import { UserProfile, UserSessionService } from 'bna-angular-auth-client';
import { LocalStorageService } from 'src/app/core/services/data/local-storage.service';
import { SHOWORGANIZATIONEMAILCOUNT } from 'src/app/shared/constants/local-storage-items.constants';

@Component({
  selector: 'app-user-profile-menu',
  templateUrl: './user-profile-menu.component.html',
  styleUrls: ['./user-profile-menu.component.scss'],
})
export class UserProfileMenuComponent implements OnInit {
  enabled = false;
  isAuthenticated = false;
  profile: UserProfile;

  constructor(
    private userSessionService: UserSessionService,
    private localStorageService: LocalStorageService) {
    this.enabled = !this.userSessionService.isIntegration;
    this.isAuthenticated = this.userSessionService.isAuthenticated();
    this.profile = this.userSessionService.getProfile();
  }
  ngOnInit(): void {
    this.userSessionService.isAuthenticated$.subscribe((result) => {
      if (!result.isAuthenticated) return;
      this.isAuthenticated = result.isAuthenticated;
      this.profile = this.userSessionService.getProfile();
    });
  }

  signOut() {
    this.localStorageService.removeItem('showLowSMSCountAlert');
    this.localStorageService.removeItem(SHOWORGANIZATIONEMAILCOUNT);
    this.userSessionService.signOut();
  }

  image404ErrorHandler(event) {
    event.target.src = '../../../../assets/images/user.png';
  }
}
